<template>
    <WMQYDatepicker 
        v-model="_value"
        v-bind="$attrs"
        :popper-class="popperClass"
        v-on="$listeners" 
    />
</template>

<script>
import WMQYDatepicker from "../../../components/WMQYDatepicker/";

export default {
  name: "WMQYDatepickerCustom",
  
  components: {
    WMQYDatepicker
  },
  
  inheritAttrs: false,

  props: {
    popperClass: {
      default: "",
      type: String
    },
    value: {
      default: null,
      type: [String, Array]
    }
  },

  data() {
    return {
      key: `QuartersCustomID-${Math.random()
        .toString(36)
        .slice(2)}`
    };
  },
  computed: {
    _value: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
        this.$emit("change", val);
      }
    }
  }
};
</script>
